module.exports = __webpack_public_path__ + "67f5922d788548be9d4900bebf2b5e63.svg";